import React, { useState } from "react";
import FundingBusiness from "../components/ui/FundingBusiness";
import FundingLiquidate from "../components/ui/FundingLiquidate";
import FundingOverview from "../components/ui/FundingOverview";
import FundingPersonal from "../components/ui/FundingPersonal";
import FundingTradelines from "../components/ui/FundingTradelines";
import FundingDebtRelief from "../components/ui/FundingDebtRelief";

function Funding() {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: "Overview",
      content: <FundingOverview />,
    },
    {
      title: "Personal",
      content: <FundingPersonal />,
    },
    {
      title: "Business",
      content: <FundingBusiness />,
    },
    {
      title: "Debt Relief",
      content: <FundingDebtRelief />,
    },
    {
      title: "Tradelines",
      content: <FundingTradelines />,
    },
    {
      title: "Liquidate",
      content: <FundingLiquidate />,
    },
  ];

  return (
    <div className="page_overflow">
      <section className="repair_credit">
        <div className="container">
          <div className="section_title">
            <h2>Funding</h2>
          </div>
          <div className="tabs-container">
            {/* Render tab titles */}
            <div className="tabs">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`tab ${activeTab === index ? "active" : ""}`}
                  onClick={() => setActiveTab(index)}
                >
                  {tab.title}
                </button>
              ))}
            </div>

            {/* Render active tab content */}
            <div className="tab-content">{tabs[activeTab].content}</div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Funding;
